import * as yup from 'yup';
export const validationSchema = yup.object().shape({
    items: yup.array().of(yup.object().shape({
        quantity: yup.number().required().positive().integer('Must be whole number.').min(1),
    })),
});
